module.exports = __webpack_public_path__ + "3dgameartandgamedesign-a6c7fd74.webp";